import { Component, OnInit, NgZone, ViewChild } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';

import { NgForm, Validators } from '@angular/forms';
import { CommonService } from '../../services/common.service';
import { ApiService } from '../../services/api.service';
import { AuthService } from '../../services/auth.service';
import { MenuController } from '@ionic/angular';
import { TranslationService } from '../../services/translation.service';

// declare function unInitializeChat():any;

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {
  @ViewChild('f', { read: NgForm }) form: any;

  defaultLocales = [{ LocaleCode: "EN", Locale: "English", LocaleId: 1033 }, { LocaleCode: "NL", Locale: "Nederlands", LocaleId: 1043 }];
  localeSelectionDisabled: boolean = true;
  locale = 1043;

  domains :string = 'master'
  controlStatus: any = {
    username: false,
    password: false
  };


  loginForm: NgForm = null;

  customLocaleSelect = {
    cssClass: 'customLocaleSelect'
  }

  submitted: boolean = false;

  constructor(private zone: NgZone,
    private router: Router,
    
    private _authService: AuthService,
    public _commonService: CommonService,
    private _apiService: ApiService,
    private menuController: MenuController,
    private _translationService: TranslationService) {}

  ngOnInit() {
  }

  ionViewWillEnter(){
    this._commonService.isLoggedIn = false;
    this.form.reset()
  }

  ionViewDidLeave(){
    if(this.loginForm) {
      this.loginForm.form.controls['username'].setValue(null);
      this.loginForm.form.controls['password'].setValue(null);
      this.loginForm.reset();
    }   
   this.submitted = false;
  }

  ionViewDidEnter(){
  
    console.log(this.form)
    // to reset login form
    if (this.loginForm) {
      this.loginForm.form.enable();
      this.loginForm.form.controls['username'].setValue(null);
      this.loginForm.form.controls['password'].setValue(null);
      this.loginForm.reset()
    }
    let password =  document.querySelector('.password');
    if (password) password.classList.remove("item-has-focus");

    if (localStorage.locale) {
      this._commonService.locale = Number(localStorage.locale);
      this.locale = Number(localStorage.locale);
    } else {
      this._commonService.locale = 1043;
      localStorage.locale = this._commonService.locale;
    }
    if (localStorage.domainLocales && localStorage.domainLocales != "undefined"){
      this.localeSelectionDisabled = false;
      this.defaultLocales = JSON.parse(localStorage.domainLocales);
    }
   
    if( (!localStorage.Logo || localStorage.Logo == 'null')) {
      this._commonService.logo = "assets/BRAND_MR_Logo.png";
      localStorage.setItem('Logo', this._commonService.logo);
    }

    if( (!localStorage.customerLogo || localStorage.customerLogo == 'null')) {
      this._commonService.customerLogo = null;
    }
    this.getOfflineSettings()
  }

  

  login(f: NgForm) {
    this.submitted = true;
    if (f.valid) {      
      //if already loged in from another domain
      if(localStorage.authenticationKey && localStorage.authenticationKey != "null"){
        this._commonService.presentLoading();
        this._translationService.getTranslation(this.locale);
        this._commonService.isLoggedIn = true;
        this._commonService.notificationsUnreadCount = localStorage.notificationsUnreadCount ? localStorage.notificationsUnreadCount : 0;
        this._commonService.domainLocales = localStorage.domainLocales ? JSON.parse(localStorage.domainLocales) : null;
        this._commonService.menuItems = localStorage.menuItems ? JSON.parse(localStorage.menuItems) : null;
        this._commonService.domainName = localStorage.domainName ? localStorage.domainName : null;
        this._commonService.locale = localStorage.locale ? localStorage.locale : 1043;

        this._commonService.domain = {
          DomainId: localStorage.domainId ? localStorage.domainId : null,
          Name: localStorage.domainName ? localStorage.domainName :null
        }


        this.router.navigate(['/dashboard'], { replaceUrl: true });
        this._commonService.dismiss();
        return;
      }

      this.loginForm = f;
      this.loginForm.form.disable();
      this._commonService.presentLoading();
      let params = {
        "userName": f.value.username.trim().toLowerCase(),
        "password": f.value.password,
        "localeCode": (localStorage.locale && !Number.isNaN(Number(localStorage.locale))) ? localStorage.locale : 1043,
      };
      this._authService.doLogin(params, 'Login').subscribe(
        async (res) => {
          if (Number(res.body.DefaultPassword)) {
            let locale = localStorage.locale;
            localStorage.clear();
            localStorage.locale = locale;
            localStorage.domainName = 'master'; //f.value.domain.trim();
    
            this._commonService.tempUserName = f.value.username.trim();
            this._commonService.tempDomainName = 'master'; //f.value.domain.trim();
            this._commonService.tempAuthKey = res.body.AuthenticationKey;
            this._commonService.tempDefaultPassword = true;
            this._commonService.dismiss();
            this.router.navigate(['/resetdefaultpassword']);
          }
          else{
            if (res.body.OTPVerification) {
              this._commonService.tempUserName = f.value.username.trim();
              this._commonService.tempDomainName = 'master'; //f.value.domain.trim();
              localStorage.setItem('otpAuthenticationKey', res.body.EnableCode);
              if(res.body.SecretKey){
                this._commonService.secretKey = res.body.SecretKey 
                this._commonService.showQrScanner = true
              }else{
                this._commonService.showQrScanner = false
              }
              
              this._commonService.dismiss();
              this.router.navigate(['/loginverification']);
            }
            else {
              let currentTime = new Date();
              localStorage.sessionStartTime = currentTime.getHours();

              localStorage.setItem('userId', res.body.UserId);
              localStorage.setItem('userName', res.body.UserName);
              localStorage.setItem('firstName', res.body.FirstName);
              localStorage.setItem('domainLocales', JSON.stringify(res.body.Locales));
              localStorage.setItem('menuItems', JSON.stringify(res.body.MenuItems));
              localStorage.setItem('domainName', res.body.DomainName);
              localStorage.setItem('authenticationKey', res.body.AuthenticationKey);
              localStorage.setItem('domainId', res.body.DomainId);
              localStorage.setItem('roleCode', res.body.RoleCode);
              localStorage.setItem('linkedToMultipleDomains', res.body.LinkedToMultipleDomains);
              localStorage.setItem('MaxAllowedCompanyPerDomain', res.body.MaxAllowedCompanyPerDomain);
              localStorage.setItem('helpImageChangeInterval', res.body.HelpImageChangeInterval);
              localStorage.setItem('notificationsUnreadCount', res.body.NotificationsUnreadCount ? res.body.NotificationsUnreadCount : 0);
              localStorage.setItem('Datecreated', res.body.Datecreated ? res.body.Datecreated : '');
              localStorage.setItem('FirstLogin', res.body.FirstLogin ? res.body.FirstLogin : 'false');
              localStorage.setItem('DomainSubscriptionContactNumber', res.body.DomainSubscriptionContactNumber ? res.body.DomainSubscriptionContactNumber : '');
              localStorage.setItem('TeamLeaderGuid',res.body.TeamLeaderGuid);
              localStorage.setItem('locale',res.body.DefaultLocale?res.body.DefaultLocale:1043);
              this.locale = res.body.DefaultLocale?res.body.DefaultLocale:1043;
              this._commonService.phoneNumber = res.body.DomainSubscriptionContactNumber ? res.body.DomainSubscriptionContactNumber : ''

              if (res.body.Logo) {
                this._commonService.logo = 'data:image/png;base64,' + res.body.Logo;
                localStorage.setItem('Logo', 'data:image/png;base64,' + res.body.Logo);
              } else {
                this._commonService.logo = null;
                localStorage.removeItem('Logo');
              }

              if (res.body.CustomerLogo) {
                this._commonService.customerLogo = 'data:image/png;base64,' + res.body.CustomerLogo;
                localStorage.setItem('customerLogo', 'data:image/png;base64,' + res.body.CustomerLogo);
              } else {
                this._commonService.customerLogo = null;
                localStorage.removeItem('customerLogo');
              }

              this._commonService.linkedToMultipleDomains = res.body.LinkedToMultipleDomains
              if(res.body.RoleCode == 'UserRole_CustomerAdmin'){
                this._commonService.isCustomerAdmin = true
              }
              if(res.body.RoleCode == 'UserRole_CustomerUser'){
                this._commonService.isCustomerUser = true
              }
              if(res.body.RoleCode == 'UserRole_Support'){
                this._commonService.isSupportUser = true
              }
              if(res.body.RoleCode  == 'UserRole_Legal'){
                this._commonService.isJuristUser = true
              }

              this._commonService.notificationsUnreadCount = res.body.NotificationsUnreadCount ? res.body.NotificationsUnreadCount : 0

             
              localStorage.setItem('userRoles', res.body.UserRoles ? JSON.stringify(res.body.UserRoles) : null);
            

              this._commonService.domainLocales = res.body.Locales;

              this._translationService.getTranslation(this.locale);
         

              if (res.body.Locales.length == 1) {
                this._commonService.locale = res.body.Locales[0].LocaleId;
                localStorage.locale = res.body.Locales[0].LocaleId;
              }
              localStorage.locale = res.body.DefaultLocale
              this._commonService.locale = res.body.DefaultLocale

              this._commonService.menuItems = res.body.MenuItems;
              this._commonService.domainName = res.body.DomainName;

              this._commonService.domain = {
                DomainId: res.body.DomainId,
                Name: res.body.DomainName
              }

              if(localStorage.currentImage){
                localStorage.removeItem('currentImage')
              }

              if(localStorage.helpDetail){
                localStorage.removeItem('helpDetail')
              }

              
              this._commonService.dismiss();

           

              
              if (this._commonService.redirectURL) {
                let url = this._commonService.redirectURL.split('/');
                this._commonService.redirectURL = null;
                this.router.navigate(['documentlibrary/' + url[2] + '/' + url[3] + '/' + url[4]]);
              }
              else if (res.body.RoleCode == 'UserRole_Administrator') {
                this._commonService.isAdmin = true;
                this._commonService.showDashboardTiles = false
                this.router.navigate(['/maintenance']);
                this._commonService.redirectURL = null;
              }
              else {this.router.navigate(['/dashboard'])
              this._commonService.redirectURL = null;
              }
              this._commonService.isLoggedIn = true;

              this._commonService.getNotificationCount();
              
              

              localStorage.domains = res.body.LinkedDomains ? JSON.stringify(res.body.LinkedDomains) : null;
              this._commonService.getFAQS()
              try{
                let moduleList = await this._apiService.getModules('', '', '', 1, 0);
                localStorage.moduleList = JSON.stringify(moduleList.body);

              }catch(error){
                  localStorage.sessionStartTime = "";
                  this._commonService.dismiss();
                  this._commonService.log(error, this._commonService.ERROR);
              }

              try {
                let settingList = await this._apiService.getSettings('', '', '', 1, 0);
                settingList.body.forEach((value, index) => {
                  if (value.SettingName == "Force2FactorAuthentication") {
                    localStorage.Force2FactorAuthentication = value.SettingValue;
                  }
                  if(value.SettingName == "TeamleaderTags"){
                    localStorage.TeamleaderTags = value.SettingValue;
                  }

                })
              } catch (error) {
                this._commonService.dismiss();
                this._commonService.log(error, this._commonService.ERROR);
              }

              //Trengo
              // unInitializeChat();

            }
          }
        },
        (err) => {
          this.submitted = false
          this._commonService.reSendEmail = this.form.form.value.username ? this.form.form.value.username.trim().toLowerCase() : null
          this.loginForm.form.enable();
          this.loginForm.form.controls['password'].reset()
        
          this._commonService.log(err, this._commonService.ERROR);
          this._commonService.dismiss();
        }
      );
    }else{
      this.submitted = true
      this.controlStatus.username = true
    }
  }

  onChangeInput(){
    this.submitted = false
  }

  async getOfflineSettings(){
    try {
      let response  = await this._apiService.getOfflineSetting();
      if(response.body.length > 0){
        response.body.forEach((value, index) => {
          if (value.SettingName == "HelpOfflinePhoneNumber") {
            this._commonService.phoneNumber = value.SettingValue
          }
  
        })
      }
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  changeLocale(){
    this._commonService.locale = this.locale;
    localStorage.locale = this.locale;
    this._translationService.getLocalTranslation(this.locale);
  }

  darkenColor(color, percent) {
    let num = parseInt(color.replace("#", ""), 16),
      amt = Math.round(2.55 * percent),
      R = (num >> 16) - amt,
      B = (num >> 8 & 0x00FF) - amt,
      G = (num & 0x0000FF) - amt;
    return "#" + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 + (B < 255 ? B < 1 ? 0 : B : 255) * 0x100 + (G < 255 ? G < 1 ? 0 : G : 255)).toString(16).slice(1);
  };

  forgetPassword() {
    this._commonService.tempEmail = this.form.form.value.username ? this.form.form.value.username.trim().toLowerCase() : null,
    this.zone.run(() => {
      this.router.navigate(['/forgot-password']);
    })
  }

  onBlurMethod(controlName){
   if(controlName == 'username'){
     this.controlStatus.username = true
   }
   if(controlName == 'password'){
    this.controlStatus.password = true
  }
  }

  onFocusMethod(controlName){
    if(controlName == 'username'){
      this.controlStatus.username = false
    }
    if(controlName == 'password'){
      this.controlStatus.password = false
    }
  }

  gotoRegistration() {
    this.zone.run(() => {
      this.router.navigate(['/registration']);
    })
  }

  localeSelectModalOpened(){
    if (this._commonService.domainLocales && this._commonService.domainLocales.length > 0){
      setTimeout(async () => {
        let alertButtons = document.querySelectorAll('.customLocaleSelect button.alert-radio-button');
        alertButtons.forEach((button, index) => {
          button.querySelector('.alert-button-inner').insertAdjacentHTML('beforeend', "<span class='flag-icon '></span>");
          button.querySelector('.flag-icon').className += this._commonService.domainLocales[index].LocaleIconUrl
        })
      }, 100)
    }
  }

}
